export default __webpack_public_path__ + "static/media/market-jp.84eed149.webp";